<div class="row ml-0 mr-0">
    <div class="col-sm-3">
        <div class="card mt-3 wrapper">
            <div class="card-img-top m-3 comment animate"></div>
            <div class="card-body">
              <div class="card-title text-truncate mb-0 comment w80 br animate"></div>
              <div class="card-title text-truncate mb-0 comment br animate"></div>
              <div class="card-title text-truncate mb-0 comment br animate"></div>
              <div class="card-title text-truncate mb-0 comment br animate"></div>
            </div>
          </div>
    </div>
    <div class="col-sm-9">
        <div class="row ml-0 mr-0">
            <div *ngFor="let git of repo; let i = index;" style="padding-left: 10px;" class="mt-3 col-sm-3 col-md-6 col-lg-3 d-flex align-items-stretch">
                <div class="card wrapper flex-fill hover-card">
                    <div class="card-body shadow">
                        <div class="card-title text-truncate mb-0 w80 comment br animate"></div>
                        <div class="card-title text-truncate mb-0 comment br animate"></div>
                        <div class="card-title text-truncate mb-0 comment br animate"></div>
                        <div class="card-title text-truncate mb-0 comment br animate"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>